module.exports = __webpack_public_path__ + "img/rexs_bone.d12182fd.jpg";